<template>
  <TopNavMenu/>
  <router-view/>
  <!-- <div class="footer">1222222222222222222222221</div> -->
</template>


<script>
import TopNavMenu from './components/nav/TopNavMenu.vue';
export default {
  name: 'App',
  components: {
    TopNavMenu
  }
};

</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

body {
  font-family: 'montserrat', sans-serif;
}

</style>
